import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum, TipoAccionEvaluacionEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
  {
      selector: 'EjecucionEvaluacionEliminacion',
      templateUrl: './ejecucionevaluacioneliminacion.component.html',
      styleUrls: ['./ejecucionevaluacioneliminacion.component.scss']
  })

export class EjecucionEvaluacionEliminacionComponent implements AfterViewInit {
  consulta!: boolean;

  @Input() tipoevaluacion!: any;
  @Output() output = new EventEmitter();

  entidad: any;
  SelGrado: any[] = [];
  SelGrupo: any[] = [];
  SelDepartamento: any[] = [];
  SelPuesto: any[] = [];

  evaluadoresestudiantes: number[] = [2,3,4,5,6];
  evaluadorespadres: number[] = [7,8,9,10,11];
  evaluadortaller: number[] = [12,13,14,15];

  dataTable: any[] = [];

  public errorActivo!: boolean;
  @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
  filtrosDisplay: Array<FiltroModel> = [];
  uriApi: string = "";
  urlApiEliminar: string = "";

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
    this.entidad = {"periodoevaluacionportipoevaluacionid": 0, "departamentoid":0, "gradoid":0, "grupoid": 0, "puestoid": 0, "nivelid":0};
  }

  ngAfterViewInit() {
    this.SelDepartamentoList();
    this.entidad.periodoevaluacionportipoevaluacionid = this.tipoevaluacion.periodoevaluacionportipoevaluacionid;
    this.entidad.nivelid = this.tipoevaluacion.nivelid;
    if(this.tipoevaluacion.tipoevaluacionid == 1){
      this.uriApi = "evaluacionpendiente/configuracion/evaluacionescolaborador";
      this.urlApiEliminar = "evaluacionpendiente/configuracion/eliminargrupocolaborador";
    }else{
      this.uriApi = "evaluacionpendiente/configuracion/evaluacionesestudiantes";
      this.urlApiEliminar = "evaluacionpendiente/configuracion/eliminargrupoevaluaciones";
      this.SelGradoList();
    }
  }

  Salir(){
    this.output.next();
  }

  SelGradoList(){
    this.appService.Get("catalogo/grado/"+ this.tipoevaluacion.nivelid).then(res => {
      if(res.status == RespuestaEstatusEnum.Success){
        if(this.tipoevaluacion.tipoevaluacionid == 2 || this.tipoevaluacion.tipoevaluacionid == 7){
          this.SelGrado = res.data.filter((grado: any) => grado.gradoid == 19);
        }else if(this.tipoevaluacion.tipoevaluacionid == 3 || this.tipoevaluacion.tipoevaluacionid == 8){
          this.SelGrado = res.data.filter((grado: any) => grado.gradoid != 19);
        }else{
          this.SelGrado = res.data;
        }
      }
    })
  }

  SelGrupoList(gradoid:number){
    if(gradoid){
      this.appService.Post("catalogo/grupofiltro", {"gradoid": gradoid, "cicloid": this.tipoevaluacion.cicloid}).then(res => {
        if(res.status == RespuestaEstatusEnum.Success){
          this.SelGrupo = res.data;
          this.entidad.grupoid = 0
        }
      })
    }else{
      this.SelGrupo = [];
      this.entidad.grupoid = 0;
    }
  }

  SelDepartamentoList(){
    this.appService.Post("configuracionrh/departamento/buscar", {}).then(res =>{
      if(res.status == RespuestaEstatusEnum.Success){
        this.SelDepartamento = res.data;
      }
    })
  }

  SelPuestoList(id:number){
    if(id){
      this.appService.Post("configuracionrh/puesto/buscar", {"departamentoid":id}).then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.SelPuesto = res.data;
        }
      })
    }else{
      this.SelPuesto = []
    }

  }

  getDatos(mostrarmensaje:boolean){
    if(mostrarmensaje){
      let opciones = this.sistemaService.GetOpcionesAceptar();
      this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Este proceso puede tomar un tiempo variable dependiendo de la información a mostrar.', opciones).then(res => {
        if (res == 1) {
          this.appService.Post(this.uriApi, this.entidad).then(res => {
            if(res.status == RespuestaEstatusEnum.Success){
              this.dataTable = res.data;
              if(this.tipoevaluacion.tipoevaluacionid != 1 && this.dataTable.length == 0){
                this.mensajeService.Alerta(AlertaEnum.Warning, 'No se encontraron evaluaciones');
              }
            }
          })
        }
    })
    }else{
      this.appService.Post(this.uriApi, this.entidad).then(res => {
        if(res.status == RespuestaEstatusEnum.Success){
          this.dataTable = res.data;
          if(this.tipoevaluacion.tipoevaluacionid != 1 && this.dataTable.length == 0){
            this.mensajeService.Alerta(AlertaEnum.Warning, 'No se encontraron evaluaciones');
          }
        }
      })
    }
  }

  eliminarpregunta(pregunta:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar la pregunta? <br> Esta acción no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminar(pregunta);
      }
  })
  }

  eliminareval(evaluacion:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar la evaluación? <br> Esto eliminara las preguntas de esta evaluacion y no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminar(evaluacion);
      }
  })
  }

  eliminarevalalumno(alumno:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción eliminara todas las evaluaciones del alumno junto con sus preguntas y no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminar(alumno);
      }
  })
  }

  apieliminar(objeto:any){
    this.appService.Post("evaluacionpendiente/configuracion/eliminarevaluaciones", objeto).then(res=>{
      if(res.status == RespuestaEstatusEnum.Success){
        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        this.getDatos(false);
      }
    })
  }

  editarevaluacion(id:number, accion:number){
    return new Promise((resolve : any) =>{
      this.appService.Post("evaluacionpendiente/configuracion/periodoportipoeditar", {"id":id, "accion":accion, "noactualizar":1}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){

          return resolve(true);
        }else{
          return resolve(false);
        }
      })
    })
  }

  eliminargrupoevaluaciones(){
    if(this.dataTable.length > 0){
      let opciones = this.sistemaService.GetOpcionesEliminar();
      this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro de que quieres eliminar la evaluación? <br> Esta acción eliminará todas las preguntas asociadas a la evaluación y no podrá deshacerse.', opciones).then(res => {
        if (res == 1) {
          this.editarevaluacion(this.entidad.periodoevaluacionportipoevaluacionid, TipoAccionEvaluacionEnum.Administrar).then(res =>{
            if(res){
              this.appService.Post(this.urlApiEliminar, this.dataTable).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                  this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                  this.getDatos(false);
                }
              })
            }
          })

        }
    })
    }else{
      this.mensajeService.Alerta(AlertaEnum.Warning, "Se requieren datos para realizar la eliminación.");
    }
  }

  eliminarevaluacionesgrupocolaborador(data:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar estas evaluaciones? <br> Esto eliminara todas las evaluaciones de esta persona y no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminarcolaborador(data);
      }
  })
  }

  eliminarevaluacioncolaborador(data:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar esta evaluación? <br> Esta acción no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminarcolaborador(data);
      }
  })
  }

  eliminarevaluaciongrupodepartamento(data:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar toda las evaluaciones de este departamento? <br> Esto eliminara todas las evaluaciones y sus preguntas y no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminarcolaborador(data);
      }
  })
  }

  eliminarevaluacionpreguntacolaborador(data:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar la pregunta? <br> Esta acción no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.apieliminarcolaborador(data);
      }
  })
  }

  apieliminarcolaborador(objecto:any){
    this.appService.Post("evaluacionpendiente/configuracion/eliminarevaluacionescolaborador", objecto).then(res=>{
      if(res.status == RespuestaEstatusEnum.Success){
        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        this.getDatos(false);
      }
    })
  }
}
